import { useVideoConferenceContext } from '../../hooks';
import { DoorOpen } from 'lucide-react';
import classes from '../ControlBar/ControlBar.module.css';

interface BreakoutRoomsButtonProps {
  /** Whether any breakout rooms are currently open */
  isActive?: boolean;
}

export const BreakoutRoomsButton = ({ isActive = false }: BreakoutRoomsButtonProps) => {
  const { toggleBreakoutRooms, extendedWidgetState } = useVideoConferenceContext();

  return (
    <button
      type="button"
      aria-pressed={extendedWidgetState.showBreakoutRooms}
      onClick={toggleBreakoutRooms}
      className={`lk-button ${classes.button}`}
    >
      <DoorOpen size={20} />
      <span className={classes.breakoutLabel}>Breakout Rooms</span>
      {isActive && (
        <span className={classes.roomsOpen}>
          <span className={classes.roomsOpenIndicator} />
          Rooms open
        </span>
      )}
    </button>
  );
};
